var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9115 14.1668V9.54352C16.9115 9.09824 16.9111 8.87548 16.8569 8.66828C16.809 8.48466 16.7302 8.31089 16.6236 8.15387C16.5033 7.97668 16.3361 7.82974 16.001 7.53652L12.001 4.03652C11.3788 3.49212 11.0677 3.22005 10.7176 3.11652C10.4091 3.02529 10.0803 3.02529 9.77181 3.11652C9.42197 3.21997 9.11133 3.49178 8.49009 4.03536L4.48877 7.53652C4.15366 7.82974 3.98649 7.97668 3.86621 8.15387C3.75962 8.31089 3.68025 8.48466 3.63227 8.66828C3.57812 8.87548 3.57812 9.09824 3.57812 9.54352V14.1668C3.57812 14.9434 3.57812 15.3315 3.70499 15.6378C3.87415 16.0462 4.19839 16.371 4.60677 16.5402C4.91306 16.6671 5.30134 16.6671 6.07791 16.6671C6.85448 16.6671 7.24319 16.6671 7.54948 16.5402C7.95786 16.371 8.28202 16.0462 8.45117 15.6379C8.57804 15.3316 8.57812 14.9433 8.57812 14.1667V13.3334C8.57812 12.4129 9.32432 11.6667 10.2448 11.6667C11.1653 11.6667 11.9115 12.4129 11.9115 13.3334V14.1667C11.9115 14.9433 11.9115 15.3316 12.0383 15.6379C12.2075 16.0462 12.5317 16.371 12.9401 16.5402C13.2464 16.6671 13.6347 16.6671 14.4112 16.6671C15.1878 16.6671 15.5765 16.6671 15.8828 16.5402C16.2912 16.371 16.6153 16.0462 16.7845 15.6378C16.9114 15.3315 16.9115 14.9434 16.9115 14.1668Z",
    stroke: "#3A3A3A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse01);
export default __webpack_public_path__ + "static/media/House_01.8f64947f38c58d83681c27b445aa7a61.svg";
export { ForwardRef as ReactComponent };